
import Vue from 'vue'
import VLazyImage from 'v-lazy-image'

export default Vue.extend({
  name: 'ProfileImage',
  props: {
    imageURL: {
      type: String,
    },
    onClick: {
      type: Function,
      required: false,
    },
    addShadow: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    VLazyImage,
  },
  data() {
    return {
      error: false,
    }
  },
  methods: {
    onClickHandler() {
      if (this.onClick) {
        return this.onClick()
      }
    },
    imgUrl(e: any) {
      e.preventDefault()
      if (!this.error) {
        this.error = true
        e.target.src = require('../../assets/img/placeholder_portrait.svg')
        e.target.classList.add('v-lazy-image-loaded')
      }
    },
  },
})
